const currentDataStarter = {
  queryValue: '',
  preview: {
    results: [],
    merchandising: {},
  },
  suggestions: {
    suggested: null,
    alternatives: [],
  },
};

const globalSearch = (
  trendingProductProfileTag,
  noResultFallbackText,
  noResultFallbackLink
) => ({
  trendingProductProfileTag,
  noResultFallbackText,
  noResultFallbackLink,
  trendingQueries: {},
  trendingProducts: [],
  query: '',
  lastQueryIdx: -1,
  currentData: currentDataStarter,

  async init() {},

  get allSearchSuggestions() {
    return [];
  },

  get searchPreviewResults() {
    return [];
  },
  get hasSearchPreviewResults() {
    return false;
  },
  get numSearchPreviewResults() {
    return 0;
  },
  get hasSuggestions() {
    return false;
  },
  get chipDisplayHeader() {
    return this.hasSuggestions ? 'Search Suggestions' : 'Trending Searches';
  },
  get trendingQueriesNormalized() {
    return [];
  },

  get productDisplayHeader() {
    if (this.hasSearchPreviewResults && this.currentSearchTerm) {
      return 'Product Matches';
    } else return 'Trending Products';
  },

  get suggestionChips() {
    return this.currentData?.suggestions?.suggested
      ? this.allSearchSuggestions
      : this.trendingQueriesNormalized;
  },

  get productsDisplay() {
    return this.hasSearchPreviewResults && this.currentSearchTerm
      ? this.searchPreviewResults
      : this.trendingProducts;
  },

  get CTAText() {
    return this.hasSearchPreviewResults
      ? `View all ${this.numSearchPreviewResults} results`
      : this.noResultFallbackText;
  },

  get searchResultsPath() {
    return '/pages/search-results-1';
  },

  get searchResultsLink() {
    const redirect = this.currentData.merchandising?.redirect;
    if (redirect) return redirect;

    const queryEscaped = encodeURIComponent(this.query);
    return `${this.searchResultsPath}?q=${queryEscaped}`;
  },

  get noResultState() {
    return this.currentSearchTerm && !this.hasSearchPreviewResults;
  },

  get CTALink() {
    if (this.hasSearchPreviewResults) {
      return this.searchResultsLink;
    } else {
      return this.noResultFallbackLink;
    }
  },

  get hideCTA() {
    if (this.hasSearchPreviewResults) {
      return false;
    }
    return (
      !this.hasSearchPreviewResults &&
      (!this.noResultFallbackLink || !this.noResultFallbackText)
    );
  },

  get currentSearchTerm() {
    return this.currentData?.queryValue || '';
  },

  showSearch() {
    this.$el.closest('dialog').showModal();
    setTimeout(() => {
      this.$refs.searchInput.focus();
    }, 310);
  },

  closeSearch() {
    this.$el.closest('dialog').close();
    this.$refs.searchInput.blur();
  },

  handleFormSubmit() {
    // TODO: adjust as necessary when changing over to suggestion-powered search
    if (this.query) {
      window.location = this.searchResultsLink;
    }
  },
});

export default globalSearch;
